import React, { useState, useEffect } from 'react';
import { getQueryVariable, fetchApi } from '../Utils/Fetch';
import { useTranslation } from 'react-i18next';
import { PAGE_STATUS_CONFIRMATION } from '../Utils/Constants';
var Markdown = require('react-remarkable');

function Confirmation() {
    const { t, ready } = useTranslation();
    var uid = getQueryVariable("uid");
    var cid = getQueryVariable("cid");
    const [salesforceStatus, setSalesforceStatus] = useState(PAGE_STATUS_CONFIRMATION.PENDING);
    useEffect(() => {
        async function checkSalesforce() {
            try {
                await fetchApi('double-opt-in', { method: 'POST', body: { uid: uid, cid: cid } });
                setSalesforceStatus(PAGE_STATUS_CONFIRMATION.SUCCESS);
            }
            catch (err) {
                console.error(err);
                setSalesforceStatus(PAGE_STATUS_CONFIRMATION.ERROR);
            }
        }
        checkSalesforce();
    }, [uid, cid]);

    if (salesforceStatus === PAGE_STATUS_CONFIRMATION.SUCCESS && ready === true) {
        return (
            <div className='container'>
                <div className="alert alert-light my-5" role="alert">
                    <h4><Markdown>{t("double_opt_in_success")}</Markdown></h4>
                </div>
                <div className="d-flex flex-row justify-content-center">
                    <div className="m-4">
                        <a className="btn btn-loropiana btn-optima" href='https://loropiana.com/'>DISCOVER MORE</a>
                    </div>
                </div>
            </div>
        )
    }
    else if (salesforceStatus === PAGE_STATUS_CONFIRMATION.ERROR && ready === true) {
        return (
            <div className='container'>
                <div className="alert alert-light my-5" role="alert">
                    <h4><Markdown>{t("double_opt_in_error")}</Markdown></h4>
                </div>
            </div>
        )
    }
    else if (salesforceStatus === PAGE_STATUS_CONFIRMATION.PENDING) {
        return (
            <div className="loader-container my-5">
                <img className='rotate' src='/assets/brand/Loro-Piana_Logo-174U_2.png' width="200" height="180" alt="logo"></img>
            </div>
        )
    }
    else {
        return (<></>);
    }
}

export default Confirmation;